import React from 'react';
import Image from 'next/image';
import { imageUrl } from 'theme';
import Button from 'seedly-component-library/button-new';
import buildConfig from 'utils/buildConfig';
import mixpanel, { trackedEvents } from 'utils/mixpanel';
import IconWrapper from './IconWrapper';

interface OwnProps {
  title?: string;
  trackingParam?: string;
  isSignup?: boolean;
  isIconOnly?: boolean;
}

const GoogleLoginButton = ({
  title = 'Continue with Google',
  trackingParam,
  isSignup = false,
  isIconOnly,
}: OwnProps) => {
  const handleButtonClick = () => {
    if (trackingParam) {
      mixpanel.track(trackedEvents.LoginSignUpModal, { param: trackingParam });
    }
    const redirectUrl = window.location.href;
    if (isSignup) {
      sessionStorage.setItem('user-signedup', 'true');
    }
    window.location.href = `${buildConfig.apiDomain}/auth/google_oauth2?origin=${redirectUrl}`;
  };

  if (isIconOnly) {
    return (
      <IconWrapper onClick={handleButtonClick}>
        <Image width={20} height={20} src={imageUrl.google} loading="lazy" />
      </IconWrapper>
    );
  }

  return (
    <Button
      onClick={handleButtonClick}
      isBlock
      size="lg"
      variant="outline"
      className="align-middle border-neutral-700 text-neutral-700 hover:bg-neutral-300 active:bg-neutral-400"
    >
      <div className="flex items-center gap-2 google-container">
        <Image width={20} height={20} src={imageUrl.google} loading="lazy" />
        <p className="text-sm font-semibold">{title}</p>
      </div>
    </Button>
  );
};

export default GoogleLoginButton;
